/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root.tsx'
import { Route as BrandPreviewRouteImport } from './routes/brand-preview.tsx'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated.tsx'
import { Route as AuthRouteRouteImport } from './routes/auth/route.tsx'
import { Route as IndexRouteImport } from './routes/index.tsx'
import { Route as AuthIndexRouteImport } from './routes/auth/index.tsx'
import { Route as AuthStatusRouteImport } from './routes/auth/status.tsx'
import { Route as AuthSignupRouteImport } from './routes/auth/signup.tsx'
import { Route as AuthSigninRouteImport } from './routes/auth/signin.tsx'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password.tsx'
import { Route as AuthenticatedUnauthorizedRouteImport } from './routes/_authenticated/unauthorized.tsx'
import { Route as AuthenticatedReportsRouteRouteImport } from './routes/_authenticated/reports/route.tsx'
import { Route as AuthenticatedFinanceRouteRouteImport } from './routes/_authenticated/finance/route.tsx'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports/index.tsx'
import { Route as AuthenticatedLicensesIndexRouteImport } from './routes/_authenticated/licenses/index.tsx'
import { Route as AuthenticatedHomeIndexRouteImport } from './routes/_authenticated/home/index.tsx'
import { Route as AuthenticatedFinanceIndexRouteImport } from './routes/_authenticated/finance/index.tsx'
import { Route as AuthenticatedReportsSubjectsRouteImport } from './routes/_authenticated/reports/subjects.tsx'
import { Route as AuthenticatedReportsSitesRouteImport } from './routes/_authenticated/reports/sites.tsx'
import { Route as AuthenticatedReportsSalespeopleRouteImport } from './routes/_authenticated/reports/salespeople.tsx'
import { Route as AuthenticatedReportsOrganizationsRouteImport } from './routes/_authenticated/reports/organizations.tsx'
import { Route as AuthenticatedReportsCustomersRouteImport } from './routes/_authenticated/reports/customers.tsx'
import { Route as AuthenticatedReportsBusinessesRouteImport } from './routes/_authenticated/reports/businesses.tsx'
import { Route as AuthenticatedMasterDataExpenseBusinessesRouteImport } from './routes/_authenticated/master-data/expense-businesses.tsx'
import { Route as AuthenticatedMasterDataBusinessesRouteImport } from './routes/_authenticated/master-data/businesses.tsx'
import { Route as AuthenticatedFinanceReceiptsRouteImport } from './routes/_authenticated/finance/receipts.tsx'
import { Route as AuthenticatedFinanceMoneyRouteImport } from './routes/_authenticated/finance/money.tsx'
import { Route as AuthenticatedFinanceGroupsRouteImport } from './routes/_authenticated/finance/groups.tsx'
import { Route as AuthenticatedFinanceExpensesRouteImport } from './routes/_authenticated/finance/expenses.tsx'
import { Route as AuthenticatedFinanceBillsRouteImport } from './routes/_authenticated/finance/bills.tsx'
import { Route as AuthenticatedCustomerManagementSubjectsRouteImport } from './routes/_authenticated/customer-management/subjects.tsx'
import { Route as AuthenticatedCustomerManagementCustomerTagsRouteImport } from './routes/_authenticated/customer-management/customer-tags.tsx'
import { Route as AuthenticatedCustomerManagementCalendarRouteImport } from './routes/_authenticated/customer-management/calendar.tsx'
import { Route as AuthenticatedContractsVariablesRouteImport } from './routes/_authenticated/contracts/variables.tsx'
import { Route as AuthenticatedContractsDocumentsRouteImport } from './routes/_authenticated/contracts/documents.tsx'
import { Route as AuthenticatedAddressSitesRouteImport } from './routes/_authenticated/address/sites.tsx'
import { Route as AuthenticatedAddressRoomsRouteImport } from './routes/_authenticated/address/rooms.tsx'
import { Route as AuthenticatedAccessMembersRouteImport } from './routes/_authenticated/access/members.tsx'
import { Route as AuthenticatedAccessApplicationsRouteImport } from './routes/_authenticated/access/applications.tsx'
import { Route as AuthenticatedAccessAccountsRouteImport } from './routes/_authenticated/access/accounts.tsx'
import { Route as AuthenticatedSystemManagementRolesRouteRouteImport } from './routes/_authenticated/system-management/roles/route.tsx'
import { Route as AuthenticatedMasterDataLegalEntitiesRouteRouteImport } from './routes/_authenticated/master-data/legal-entities/route.tsx'
import { Route as AuthenticatedContractsTemplatesRouteRouteImport } from './routes/_authenticated/contracts/templates/route.tsx'
import { Route as AuthenticatedSystemManagementRolesIndexRouteImport } from './routes/_authenticated/system-management/roles/index.tsx'
import { Route as AuthenticatedSystemManagementBotsIndexRouteImport } from './routes/_authenticated/system-management/bots/index.tsx'
import { Route as AuthenticatedOrdersServiceIndexRouteImport } from './routes/_authenticated/orders/service/index.tsx'
import { Route as AuthenticatedOrdersRentalsIndexRouteImport } from './routes/_authenticated/orders/rentals/index.tsx'
import { Route as AuthenticatedOrdersGroupsIndexRouteImport } from './routes/_authenticated/orders/groups/index.tsx'
import { Route as AuthenticatedMasterDataLegalEntitiesIndexRouteImport } from './routes/_authenticated/master-data/legal-entities/index.tsx'
import { Route as AuthenticatedCustomerManagementCustomersIndexRouteImport } from './routes/_authenticated/customer-management/customers/index.tsx'
import { Route as AuthenticatedContractsTemplatesIndexRouteImport } from './routes/_authenticated/contracts/templates/index.tsx'
import { Route as AuthenticatedSystemManagementRolesNewRouteImport } from './routes/_authenticated/system-management/roles/new.tsx'
import { Route as AuthenticatedSystemManagementRolesRoleIdRouteImport } from './routes/_authenticated/system-management/roles/$roleId.tsx'
import { Route as AuthenticatedSystemManagementBotsBotIdRouteImport } from './routes/_authenticated/system-management/bots/$botId.tsx'
import { Route as AuthenticatedOrdersServiceNewRouteImport } from './routes/_authenticated/orders/service/new.tsx'
import { Route as AuthenticatedOrdersRentalsNewRouteImport } from './routes/_authenticated/orders/rentals/new.tsx'
import { Route as AuthenticatedOrdersRentalsBatchNewRouteImport } from './routes/_authenticated/orders/rentals/batch-new.tsx'
import { Route as AuthenticatedOrdersRentalsRentalIdRouteImport } from './routes/_authenticated/orders/rentals/$rentalId.tsx'
import { Route as AuthenticatedOrdersGroupsGroupIdRouteImport } from './routes/_authenticated/orders/groups/$groupId.tsx'
import { Route as AuthenticatedOrdersContractsPrintRouteImport } from './routes/_authenticated/orders/contracts/print.tsx'
import { Route as AuthenticatedMasterDataLegalEntitiesNewRouteImport } from './routes/_authenticated/master-data/legal-entities/new.tsx'
import { Route as AuthenticatedFinanceGroupsReceiptBatchRouteImport } from './routes/_authenticated/finance/groups_.receipt-batch.tsx'
import { Route as AuthenticatedCustomerManagementCustomersNewRouteImport } from './routes/_authenticated/customer-management/customers/new.tsx'
import { Route as AuthenticatedContractsViewDocumentIdRouteImport } from './routes/_authenticated/contracts/view/$documentId.tsx'
import { Route as AuthenticatedContractsTemplatesTemplateIdRouteImport } from './routes/_authenticated/contracts/templates/$templateId.tsx'
import { Route as AuthenticatedContractsEditDocumentIdRouteImport } from './routes/_authenticated/contracts/edit/$documentId.tsx'
import { Route as AuthenticatedOrdersServiceOrderIdIndexRouteImport } from './routes/_authenticated/orders/service/$orderId/index.tsx'
import { Route as AuthenticatedCustomerManagementCustomersCustomerIdIndexRouteImport } from './routes/_authenticated/customer-management/customers/$customerId/index.tsx'
import { Route as AuthenticatedOrdersServiceContractsBatchRouteImport } from './routes/_authenticated/orders/service/contracts/batch.tsx'
import { Route as AuthenticatedOrdersServiceContractOrderIdRouteImport } from './routes/_authenticated/orders/service/contract/$orderId.tsx'
import { Route as AuthenticatedOrdersServiceOrderIdEditRouteImport } from './routes/_authenticated/orders/service/$orderId/edit.tsx'
import { Route as AuthenticatedOrdersRentalsMaterialsBatchRouteImport } from './routes/_authenticated/orders/rentals/materials/batch.tsx'
import { Route as AuthenticatedOrdersRentalsEditRentalIdRouteImport } from './routes/_authenticated/orders/rentals/edit/$rentalId.tsx'
import { Route as AuthenticatedOrdersRentalsContractsBatchRouteImport } from './routes/_authenticated/orders/rentals/contracts/batch.tsx'
import { Route as AuthenticatedOrdersRentalsContractRentalIdRouteImport } from './routes/_authenticated/orders/rentals/contract/$rentalId.tsx'
import { Route as AuthenticatedMasterDataLegalEntitiesOrganizationIdEditRouteImport } from './routes/_authenticated/master-data/legal-entities/$organizationId/edit.tsx'
import { Route as AuthenticatedCustomerManagementSubjectsMaterialsBatchRouteImport } from './routes/_authenticated/customer-management/subjects_.materials.batch.tsx'
import { Route as AuthenticatedCustomerManagementCustomersCustomerIdEditRouteImport } from './routes/_authenticated/customer-management/customers/$customerId/edit.tsx'
import { Route as AuthenticatedCustomerManagementCustomersCustomerIdDocumentsRouteImport } from './routes/_authenticated/customer-management/customers/$customerId/documents.tsx'
import { Route as AuthenticatedCustomerManagementCustomersCustomerIdCollectionPolicyRouteImport } from './routes/_authenticated/customer-management/customers/$customerId/collection-policy.tsx'
import { Route as AuthenticatedContractsTemplatesVersionsVersionIdRouteImport } from './routes/_authenticated/contracts/templates/versions/$versionId.tsx'
import { Route as AuthenticatedAddressRoomsRoomIdRentalsRouteImport } from './routes/_authenticated/address/rooms_/$roomId/rentals.tsx'

const BrandPreviewRoute = BrandPreviewRouteImport.update({
  id: '/brand-preview',
  path: '/brand-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthStatusRoute = AuthStatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthenticatedUnauthorizedRoute =
  AuthenticatedUnauthorizedRouteImport.update({
    id: '/unauthorized',
    path: '/unauthorized',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsRouteRoute =
  AuthenticatedReportsRouteRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFinanceRouteRoute =
  AuthenticatedFinanceRouteRouteImport.update({
    id: '/finance',
    path: '/finance',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedReportsRouteRoute,
  } as any)
const AuthenticatedLicensesIndexRoute =
  AuthenticatedLicensesIndexRouteImport.update({
    id: '/licenses/',
    path: '/licenses/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHomeIndexRoute = AuthenticatedHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFinanceIndexRoute =
  AuthenticatedFinanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedFinanceRouteRoute,
  } as any)
const AuthenticatedReportsSubjectsRoute =
  AuthenticatedReportsSubjectsRouteImport.update({
    id: '/subjects',
    path: '/subjects',
    getParentRoute: () => AuthenticatedReportsRouteRoute,
  } as any)
const AuthenticatedReportsSitesRoute =
  AuthenticatedReportsSitesRouteImport.update({
    id: '/sites',
    path: '/sites',
    getParentRoute: () => AuthenticatedReportsRouteRoute,
  } as any)
const AuthenticatedReportsSalespeopleRoute =
  AuthenticatedReportsSalespeopleRouteImport.update({
    id: '/salespeople',
    path: '/salespeople',
    getParentRoute: () => AuthenticatedReportsRouteRoute,
  } as any)
const AuthenticatedReportsOrganizationsRoute =
  AuthenticatedReportsOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthenticatedReportsRouteRoute,
  } as any)
const AuthenticatedReportsCustomersRoute =
  AuthenticatedReportsCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AuthenticatedReportsRouteRoute,
  } as any)
const AuthenticatedReportsBusinessesRoute =
  AuthenticatedReportsBusinessesRouteImport.update({
    id: '/businesses',
    path: '/businesses',
    getParentRoute: () => AuthenticatedReportsRouteRoute,
  } as any)
const AuthenticatedMasterDataExpenseBusinessesRoute =
  AuthenticatedMasterDataExpenseBusinessesRouteImport.update({
    id: '/master-data/expense-businesses',
    path: '/master-data/expense-businesses',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMasterDataBusinessesRoute =
  AuthenticatedMasterDataBusinessesRouteImport.update({
    id: '/master-data/businesses',
    path: '/master-data/businesses',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFinanceReceiptsRoute =
  AuthenticatedFinanceReceiptsRouteImport.update({
    id: '/receipts',
    path: '/receipts',
    getParentRoute: () => AuthenticatedFinanceRouteRoute,
  } as any)
const AuthenticatedFinanceMoneyRoute =
  AuthenticatedFinanceMoneyRouteImport.update({
    id: '/money',
    path: '/money',
    getParentRoute: () => AuthenticatedFinanceRouteRoute,
  } as any)
const AuthenticatedFinanceGroupsRoute =
  AuthenticatedFinanceGroupsRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => AuthenticatedFinanceRouteRoute,
  } as any)
const AuthenticatedFinanceExpensesRoute =
  AuthenticatedFinanceExpensesRouteImport.update({
    id: '/expenses',
    path: '/expenses',
    getParentRoute: () => AuthenticatedFinanceRouteRoute,
  } as any)
const AuthenticatedFinanceBillsRoute =
  AuthenticatedFinanceBillsRouteImport.update({
    id: '/bills',
    path: '/bills',
    getParentRoute: () => AuthenticatedFinanceRouteRoute,
  } as any)
const AuthenticatedCustomerManagementSubjectsRoute =
  AuthenticatedCustomerManagementSubjectsRouteImport.update({
    id: '/customer-management/subjects',
    path: '/customer-management/subjects',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomerManagementCustomerTagsRoute =
  AuthenticatedCustomerManagementCustomerTagsRouteImport.update({
    id: '/customer-management/customer-tags',
    path: '/customer-management/customer-tags',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomerManagementCalendarRoute =
  AuthenticatedCustomerManagementCalendarRouteImport.update({
    id: '/customer-management/calendar',
    path: '/customer-management/calendar',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractsVariablesRoute =
  AuthenticatedContractsVariablesRouteImport.update({
    id: '/contracts/variables',
    path: '/contracts/variables',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractsDocumentsRoute =
  AuthenticatedContractsDocumentsRouteImport.update({
    id: '/contracts/documents',
    path: '/contracts/documents',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAddressSitesRoute =
  AuthenticatedAddressSitesRouteImport.update({
    id: '/address/sites',
    path: '/address/sites',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAddressRoomsRoute =
  AuthenticatedAddressRoomsRouteImport.update({
    id: '/address/rooms',
    path: '/address/rooms',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccessMembersRoute =
  AuthenticatedAccessMembersRouteImport.update({
    id: '/access/members',
    path: '/access/members',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccessApplicationsRoute =
  AuthenticatedAccessApplicationsRouteImport.update({
    id: '/access/applications',
    path: '/access/applications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccessAccountsRoute =
  AuthenticatedAccessAccountsRouteImport.update({
    id: '/access/accounts',
    path: '/access/accounts',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSystemManagementRolesRouteRoute =
  AuthenticatedSystemManagementRolesRouteRouteImport.update({
    id: '/system-management/roles',
    path: '/system-management/roles',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMasterDataLegalEntitiesRouteRoute =
  AuthenticatedMasterDataLegalEntitiesRouteRouteImport.update({
    id: '/master-data/legal-entities',
    path: '/master-data/legal-entities',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractsTemplatesRouteRoute =
  AuthenticatedContractsTemplatesRouteRouteImport.update({
    id: '/contracts/templates',
    path: '/contracts/templates',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSystemManagementRolesIndexRoute =
  AuthenticatedSystemManagementRolesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSystemManagementRolesRouteRoute,
  } as any)
const AuthenticatedSystemManagementBotsIndexRoute =
  AuthenticatedSystemManagementBotsIndexRouteImport.update({
    id: '/system-management/bots/',
    path: '/system-management/bots/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersServiceIndexRoute =
  AuthenticatedOrdersServiceIndexRouteImport.update({
    id: '/orders/service/',
    path: '/orders/service/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersRentalsIndexRoute =
  AuthenticatedOrdersRentalsIndexRouteImport.update({
    id: '/orders/rentals/',
    path: '/orders/rentals/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersGroupsIndexRoute =
  AuthenticatedOrdersGroupsIndexRouteImport.update({
    id: '/orders/groups/',
    path: '/orders/groups/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMasterDataLegalEntitiesIndexRoute =
  AuthenticatedMasterDataLegalEntitiesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMasterDataLegalEntitiesRouteRoute,
  } as any)
const AuthenticatedCustomerManagementCustomersIndexRoute =
  AuthenticatedCustomerManagementCustomersIndexRouteImport.update({
    id: '/customer-management/customers/',
    path: '/customer-management/customers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractsTemplatesIndexRoute =
  AuthenticatedContractsTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedContractsTemplatesRouteRoute,
  } as any)
const AuthenticatedSystemManagementRolesNewRoute =
  AuthenticatedSystemManagementRolesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedSystemManagementRolesRouteRoute,
  } as any)
const AuthenticatedSystemManagementRolesRoleIdRoute =
  AuthenticatedSystemManagementRolesRoleIdRouteImport.update({
    id: '/$roleId',
    path: '/$roleId',
    getParentRoute: () => AuthenticatedSystemManagementRolesRouteRoute,
  } as any)
const AuthenticatedSystemManagementBotsBotIdRoute =
  AuthenticatedSystemManagementBotsBotIdRouteImport.update({
    id: '/system-management/bots/$botId',
    path: '/system-management/bots/$botId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersServiceNewRoute =
  AuthenticatedOrdersServiceNewRouteImport.update({
    id: '/orders/service/new',
    path: '/orders/service/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersRentalsNewRoute =
  AuthenticatedOrdersRentalsNewRouteImport.update({
    id: '/orders/rentals/new',
    path: '/orders/rentals/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersRentalsBatchNewRoute =
  AuthenticatedOrdersRentalsBatchNewRouteImport.update({
    id: '/orders/rentals/batch-new',
    path: '/orders/rentals/batch-new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersRentalsRentalIdRoute =
  AuthenticatedOrdersRentalsRentalIdRouteImport.update({
    id: '/orders/rentals/$rentalId',
    path: '/orders/rentals/$rentalId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersGroupsGroupIdRoute =
  AuthenticatedOrdersGroupsGroupIdRouteImport.update({
    id: '/orders/groups/$groupId',
    path: '/orders/groups/$groupId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersContractsPrintRoute =
  AuthenticatedOrdersContractsPrintRouteImport.update({
    id: '/orders/contracts/print',
    path: '/orders/contracts/print',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMasterDataLegalEntitiesNewRoute =
  AuthenticatedMasterDataLegalEntitiesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedMasterDataLegalEntitiesRouteRoute,
  } as any)
const AuthenticatedFinanceGroupsReceiptBatchRoute =
  AuthenticatedFinanceGroupsReceiptBatchRouteImport.update({
    id: '/groups_/receipt-batch',
    path: '/groups/receipt-batch',
    getParentRoute: () => AuthenticatedFinanceRouteRoute,
  } as any)
const AuthenticatedCustomerManagementCustomersNewRoute =
  AuthenticatedCustomerManagementCustomersNewRouteImport.update({
    id: '/customer-management/customers/new',
    path: '/customer-management/customers/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractsViewDocumentIdRoute =
  AuthenticatedContractsViewDocumentIdRouteImport.update({
    id: '/contracts/view/$documentId',
    path: '/contracts/view/$documentId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractsTemplatesTemplateIdRoute =
  AuthenticatedContractsTemplatesTemplateIdRouteImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => AuthenticatedContractsTemplatesRouteRoute,
  } as any)
const AuthenticatedContractsEditDocumentIdRoute =
  AuthenticatedContractsEditDocumentIdRouteImport.update({
    id: '/contracts/edit/$documentId',
    path: '/contracts/edit/$documentId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersServiceOrderIdIndexRoute =
  AuthenticatedOrdersServiceOrderIdIndexRouteImport.update({
    id: '/orders/service/$orderId/',
    path: '/orders/service/$orderId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomerManagementCustomersCustomerIdIndexRoute =
  AuthenticatedCustomerManagementCustomersCustomerIdIndexRouteImport.update({
    id: '/customer-management/customers/$customerId/',
    path: '/customer-management/customers/$customerId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersServiceContractsBatchRoute =
  AuthenticatedOrdersServiceContractsBatchRouteImport.update({
    id: '/orders/service/contracts/batch',
    path: '/orders/service/contracts/batch',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersServiceContractOrderIdRoute =
  AuthenticatedOrdersServiceContractOrderIdRouteImport.update({
    id: '/orders/service/contract/$orderId',
    path: '/orders/service/contract/$orderId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersServiceOrderIdEditRoute =
  AuthenticatedOrdersServiceOrderIdEditRouteImport.update({
    id: '/orders/service/$orderId/edit',
    path: '/orders/service/$orderId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersRentalsMaterialsBatchRoute =
  AuthenticatedOrdersRentalsMaterialsBatchRouteImport.update({
    id: '/orders/rentals/materials/batch',
    path: '/orders/rentals/materials/batch',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersRentalsEditRentalIdRoute =
  AuthenticatedOrdersRentalsEditRentalIdRouteImport.update({
    id: '/orders/rentals/edit/$rentalId',
    path: '/orders/rentals/edit/$rentalId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersRentalsContractsBatchRoute =
  AuthenticatedOrdersRentalsContractsBatchRouteImport.update({
    id: '/orders/rentals/contracts/batch',
    path: '/orders/rentals/contracts/batch',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersRentalsContractRentalIdRoute =
  AuthenticatedOrdersRentalsContractRentalIdRouteImport.update({
    id: '/orders/rentals/contract/$rentalId',
    path: '/orders/rentals/contract/$rentalId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMasterDataLegalEntitiesOrganizationIdEditRoute =
  AuthenticatedMasterDataLegalEntitiesOrganizationIdEditRouteImport.update({
    id: '/$organizationId/edit',
    path: '/$organizationId/edit',
    getParentRoute: () => AuthenticatedMasterDataLegalEntitiesRouteRoute,
  } as any)
const AuthenticatedCustomerManagementSubjectsMaterialsBatchRoute =
  AuthenticatedCustomerManagementSubjectsMaterialsBatchRouteImport.update({
    id: '/customer-management/subjects_/materials/batch',
    path: '/customer-management/subjects/materials/batch',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomerManagementCustomersCustomerIdEditRoute =
  AuthenticatedCustomerManagementCustomersCustomerIdEditRouteImport.update({
    id: '/customer-management/customers/$customerId/edit',
    path: '/customer-management/customers/$customerId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomerManagementCustomersCustomerIdDocumentsRoute =
  AuthenticatedCustomerManagementCustomersCustomerIdDocumentsRouteImport.update(
    {
      id: '/customer-management/customers/$customerId/documents',
      path: '/customer-management/customers/$customerId/documents',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )
const AuthenticatedCustomerManagementCustomersCustomerIdCollectionPolicyRoute =
  AuthenticatedCustomerManagementCustomersCustomerIdCollectionPolicyRouteImport.update(
    {
      id: '/customer-management/customers/$customerId/collection-policy',
      path: '/customer-management/customers/$customerId/collection-policy',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )
const AuthenticatedContractsTemplatesVersionsVersionIdRoute =
  AuthenticatedContractsTemplatesVersionsVersionIdRouteImport.update({
    id: '/versions/$versionId',
    path: '/versions/$versionId',
    getParentRoute: () => AuthenticatedContractsTemplatesRouteRoute,
  } as any)
const AuthenticatedAddressRoomsRoomIdRentalsRoute =
  AuthenticatedAddressRoomsRoomIdRentalsRouteImport.update({
    id: '/address/rooms_/$roomId/rentals',
    path: '/address/rooms/$roomId/rentals',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/brand-preview': typeof BrandPreviewRoute
  '/finance': typeof AuthenticatedFinanceRouteRouteWithChildren
  '/reports': typeof AuthenticatedReportsRouteRouteWithChildren
  '/unauthorized': typeof AuthenticatedUnauthorizedRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/status': typeof AuthStatusRoute
  '/auth/': typeof AuthIndexRoute
  '/contracts/templates': typeof AuthenticatedContractsTemplatesRouteRouteWithChildren
  '/master-data/legal-entities': typeof AuthenticatedMasterDataLegalEntitiesRouteRouteWithChildren
  '/system-management/roles': typeof AuthenticatedSystemManagementRolesRouteRouteWithChildren
  '/access/accounts': typeof AuthenticatedAccessAccountsRoute
  '/access/applications': typeof AuthenticatedAccessApplicationsRoute
  '/access/members': typeof AuthenticatedAccessMembersRoute
  '/address/rooms': typeof AuthenticatedAddressRoomsRoute
  '/address/sites': typeof AuthenticatedAddressSitesRoute
  '/contracts/documents': typeof AuthenticatedContractsDocumentsRoute
  '/contracts/variables': typeof AuthenticatedContractsVariablesRoute
  '/customer-management/calendar': typeof AuthenticatedCustomerManagementCalendarRoute
  '/customer-management/customer-tags': typeof AuthenticatedCustomerManagementCustomerTagsRoute
  '/customer-management/subjects': typeof AuthenticatedCustomerManagementSubjectsRoute
  '/finance/bills': typeof AuthenticatedFinanceBillsRoute
  '/finance/expenses': typeof AuthenticatedFinanceExpensesRoute
  '/finance/groups': typeof AuthenticatedFinanceGroupsRoute
  '/finance/money': typeof AuthenticatedFinanceMoneyRoute
  '/finance/receipts': typeof AuthenticatedFinanceReceiptsRoute
  '/master-data/businesses': typeof AuthenticatedMasterDataBusinessesRoute
  '/master-data/expense-businesses': typeof AuthenticatedMasterDataExpenseBusinessesRoute
  '/reports/businesses': typeof AuthenticatedReportsBusinessesRoute
  '/reports/customers': typeof AuthenticatedReportsCustomersRoute
  '/reports/organizations': typeof AuthenticatedReportsOrganizationsRoute
  '/reports/salespeople': typeof AuthenticatedReportsSalespeopleRoute
  '/reports/sites': typeof AuthenticatedReportsSitesRoute
  '/reports/subjects': typeof AuthenticatedReportsSubjectsRoute
  '/finance/': typeof AuthenticatedFinanceIndexRoute
  '/home/': typeof AuthenticatedHomeIndexRoute
  '/licenses/': typeof AuthenticatedLicensesIndexRoute
  '/reports/': typeof AuthenticatedReportsIndexRoute
  '/contracts/edit/$documentId': typeof AuthenticatedContractsEditDocumentIdRoute
  '/contracts/templates/$templateId': typeof AuthenticatedContractsTemplatesTemplateIdRoute
  '/contracts/view/$documentId': typeof AuthenticatedContractsViewDocumentIdRoute
  '/customer-management/customers/new': typeof AuthenticatedCustomerManagementCustomersNewRoute
  '/finance/groups/receipt-batch': typeof AuthenticatedFinanceGroupsReceiptBatchRoute
  '/master-data/legal-entities/new': typeof AuthenticatedMasterDataLegalEntitiesNewRoute
  '/orders/contracts/print': typeof AuthenticatedOrdersContractsPrintRoute
  '/orders/groups/$groupId': typeof AuthenticatedOrdersGroupsGroupIdRoute
  '/orders/rentals/$rentalId': typeof AuthenticatedOrdersRentalsRentalIdRoute
  '/orders/rentals/batch-new': typeof AuthenticatedOrdersRentalsBatchNewRoute
  '/orders/rentals/new': typeof AuthenticatedOrdersRentalsNewRoute
  '/orders/service/new': typeof AuthenticatedOrdersServiceNewRoute
  '/system-management/bots/$botId': typeof AuthenticatedSystemManagementBotsBotIdRoute
  '/system-management/roles/$roleId': typeof AuthenticatedSystemManagementRolesRoleIdRoute
  '/system-management/roles/new': typeof AuthenticatedSystemManagementRolesNewRoute
  '/contracts/templates/': typeof AuthenticatedContractsTemplatesIndexRoute
  '/customer-management/customers/': typeof AuthenticatedCustomerManagementCustomersIndexRoute
  '/master-data/legal-entities/': typeof AuthenticatedMasterDataLegalEntitiesIndexRoute
  '/orders/groups/': typeof AuthenticatedOrdersGroupsIndexRoute
  '/orders/rentals/': typeof AuthenticatedOrdersRentalsIndexRoute
  '/orders/service/': typeof AuthenticatedOrdersServiceIndexRoute
  '/system-management/bots/': typeof AuthenticatedSystemManagementBotsIndexRoute
  '/system-management/roles/': typeof AuthenticatedSystemManagementRolesIndexRoute
  '/address/rooms/$roomId/rentals': typeof AuthenticatedAddressRoomsRoomIdRentalsRoute
  '/contracts/templates/versions/$versionId': typeof AuthenticatedContractsTemplatesVersionsVersionIdRoute
  '/customer-management/customers/$customerId/collection-policy': typeof AuthenticatedCustomerManagementCustomersCustomerIdCollectionPolicyRoute
  '/customer-management/customers/$customerId/documents': typeof AuthenticatedCustomerManagementCustomersCustomerIdDocumentsRoute
  '/customer-management/customers/$customerId/edit': typeof AuthenticatedCustomerManagementCustomersCustomerIdEditRoute
  '/customer-management/subjects/materials/batch': typeof AuthenticatedCustomerManagementSubjectsMaterialsBatchRoute
  '/master-data/legal-entities/$organizationId/edit': typeof AuthenticatedMasterDataLegalEntitiesOrganizationIdEditRoute
  '/orders/rentals/contract/$rentalId': typeof AuthenticatedOrdersRentalsContractRentalIdRoute
  '/orders/rentals/contracts/batch': typeof AuthenticatedOrdersRentalsContractsBatchRoute
  '/orders/rentals/edit/$rentalId': typeof AuthenticatedOrdersRentalsEditRentalIdRoute
  '/orders/rentals/materials/batch': typeof AuthenticatedOrdersRentalsMaterialsBatchRoute
  '/orders/service/$orderId/edit': typeof AuthenticatedOrdersServiceOrderIdEditRoute
  '/orders/service/contract/$orderId': typeof AuthenticatedOrdersServiceContractOrderIdRoute
  '/orders/service/contracts/batch': typeof AuthenticatedOrdersServiceContractsBatchRoute
  '/customer-management/customers/$customerId/': typeof AuthenticatedCustomerManagementCustomersCustomerIdIndexRoute
  '/orders/service/$orderId/': typeof AuthenticatedOrdersServiceOrderIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/brand-preview': typeof BrandPreviewRoute
  '/unauthorized': typeof AuthenticatedUnauthorizedRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/status': typeof AuthStatusRoute
  '/auth': typeof AuthIndexRoute
  '/access/accounts': typeof AuthenticatedAccessAccountsRoute
  '/access/applications': typeof AuthenticatedAccessApplicationsRoute
  '/access/members': typeof AuthenticatedAccessMembersRoute
  '/address/rooms': typeof AuthenticatedAddressRoomsRoute
  '/address/sites': typeof AuthenticatedAddressSitesRoute
  '/contracts/documents': typeof AuthenticatedContractsDocumentsRoute
  '/contracts/variables': typeof AuthenticatedContractsVariablesRoute
  '/customer-management/calendar': typeof AuthenticatedCustomerManagementCalendarRoute
  '/customer-management/customer-tags': typeof AuthenticatedCustomerManagementCustomerTagsRoute
  '/customer-management/subjects': typeof AuthenticatedCustomerManagementSubjectsRoute
  '/finance/bills': typeof AuthenticatedFinanceBillsRoute
  '/finance/expenses': typeof AuthenticatedFinanceExpensesRoute
  '/finance/groups': typeof AuthenticatedFinanceGroupsRoute
  '/finance/money': typeof AuthenticatedFinanceMoneyRoute
  '/finance/receipts': typeof AuthenticatedFinanceReceiptsRoute
  '/master-data/businesses': typeof AuthenticatedMasterDataBusinessesRoute
  '/master-data/expense-businesses': typeof AuthenticatedMasterDataExpenseBusinessesRoute
  '/reports/businesses': typeof AuthenticatedReportsBusinessesRoute
  '/reports/customers': typeof AuthenticatedReportsCustomersRoute
  '/reports/organizations': typeof AuthenticatedReportsOrganizationsRoute
  '/reports/salespeople': typeof AuthenticatedReportsSalespeopleRoute
  '/reports/sites': typeof AuthenticatedReportsSitesRoute
  '/reports/subjects': typeof AuthenticatedReportsSubjectsRoute
  '/finance': typeof AuthenticatedFinanceIndexRoute
  '/home': typeof AuthenticatedHomeIndexRoute
  '/licenses': typeof AuthenticatedLicensesIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/contracts/edit/$documentId': typeof AuthenticatedContractsEditDocumentIdRoute
  '/contracts/templates/$templateId': typeof AuthenticatedContractsTemplatesTemplateIdRoute
  '/contracts/view/$documentId': typeof AuthenticatedContractsViewDocumentIdRoute
  '/customer-management/customers/new': typeof AuthenticatedCustomerManagementCustomersNewRoute
  '/finance/groups/receipt-batch': typeof AuthenticatedFinanceGroupsReceiptBatchRoute
  '/master-data/legal-entities/new': typeof AuthenticatedMasterDataLegalEntitiesNewRoute
  '/orders/contracts/print': typeof AuthenticatedOrdersContractsPrintRoute
  '/orders/groups/$groupId': typeof AuthenticatedOrdersGroupsGroupIdRoute
  '/orders/rentals/$rentalId': typeof AuthenticatedOrdersRentalsRentalIdRoute
  '/orders/rentals/batch-new': typeof AuthenticatedOrdersRentalsBatchNewRoute
  '/orders/rentals/new': typeof AuthenticatedOrdersRentalsNewRoute
  '/orders/service/new': typeof AuthenticatedOrdersServiceNewRoute
  '/system-management/bots/$botId': typeof AuthenticatedSystemManagementBotsBotIdRoute
  '/system-management/roles/$roleId': typeof AuthenticatedSystemManagementRolesRoleIdRoute
  '/system-management/roles/new': typeof AuthenticatedSystemManagementRolesNewRoute
  '/contracts/templates': typeof AuthenticatedContractsTemplatesIndexRoute
  '/customer-management/customers': typeof AuthenticatedCustomerManagementCustomersIndexRoute
  '/master-data/legal-entities': typeof AuthenticatedMasterDataLegalEntitiesIndexRoute
  '/orders/groups': typeof AuthenticatedOrdersGroupsIndexRoute
  '/orders/rentals': typeof AuthenticatedOrdersRentalsIndexRoute
  '/orders/service': typeof AuthenticatedOrdersServiceIndexRoute
  '/system-management/bots': typeof AuthenticatedSystemManagementBotsIndexRoute
  '/system-management/roles': typeof AuthenticatedSystemManagementRolesIndexRoute
  '/address/rooms/$roomId/rentals': typeof AuthenticatedAddressRoomsRoomIdRentalsRoute
  '/contracts/templates/versions/$versionId': typeof AuthenticatedContractsTemplatesVersionsVersionIdRoute
  '/customer-management/customers/$customerId/collection-policy': typeof AuthenticatedCustomerManagementCustomersCustomerIdCollectionPolicyRoute
  '/customer-management/customers/$customerId/documents': typeof AuthenticatedCustomerManagementCustomersCustomerIdDocumentsRoute
  '/customer-management/customers/$customerId/edit': typeof AuthenticatedCustomerManagementCustomersCustomerIdEditRoute
  '/customer-management/subjects/materials/batch': typeof AuthenticatedCustomerManagementSubjectsMaterialsBatchRoute
  '/master-data/legal-entities/$organizationId/edit': typeof AuthenticatedMasterDataLegalEntitiesOrganizationIdEditRoute
  '/orders/rentals/contract/$rentalId': typeof AuthenticatedOrdersRentalsContractRentalIdRoute
  '/orders/rentals/contracts/batch': typeof AuthenticatedOrdersRentalsContractsBatchRoute
  '/orders/rentals/edit/$rentalId': typeof AuthenticatedOrdersRentalsEditRentalIdRoute
  '/orders/rentals/materials/batch': typeof AuthenticatedOrdersRentalsMaterialsBatchRoute
  '/orders/service/$orderId/edit': typeof AuthenticatedOrdersServiceOrderIdEditRoute
  '/orders/service/contract/$orderId': typeof AuthenticatedOrdersServiceContractOrderIdRoute
  '/orders/service/contracts/batch': typeof AuthenticatedOrdersServiceContractsBatchRoute
  '/customer-management/customers/$customerId': typeof AuthenticatedCustomerManagementCustomersCustomerIdIndexRoute
  '/orders/service/$orderId': typeof AuthenticatedOrdersServiceOrderIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/brand-preview': typeof BrandPreviewRoute
  '/_authenticated/finance': typeof AuthenticatedFinanceRouteRouteWithChildren
  '/_authenticated/reports': typeof AuthenticatedReportsRouteRouteWithChildren
  '/_authenticated/unauthorized': typeof AuthenticatedUnauthorizedRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/status': typeof AuthStatusRoute
  '/auth/': typeof AuthIndexRoute
  '/_authenticated/contracts/templates': typeof AuthenticatedContractsTemplatesRouteRouteWithChildren
  '/_authenticated/master-data/legal-entities': typeof AuthenticatedMasterDataLegalEntitiesRouteRouteWithChildren
  '/_authenticated/system-management/roles': typeof AuthenticatedSystemManagementRolesRouteRouteWithChildren
  '/_authenticated/access/accounts': typeof AuthenticatedAccessAccountsRoute
  '/_authenticated/access/applications': typeof AuthenticatedAccessApplicationsRoute
  '/_authenticated/access/members': typeof AuthenticatedAccessMembersRoute
  '/_authenticated/address/rooms': typeof AuthenticatedAddressRoomsRoute
  '/_authenticated/address/sites': typeof AuthenticatedAddressSitesRoute
  '/_authenticated/contracts/documents': typeof AuthenticatedContractsDocumentsRoute
  '/_authenticated/contracts/variables': typeof AuthenticatedContractsVariablesRoute
  '/_authenticated/customer-management/calendar': typeof AuthenticatedCustomerManagementCalendarRoute
  '/_authenticated/customer-management/customer-tags': typeof AuthenticatedCustomerManagementCustomerTagsRoute
  '/_authenticated/customer-management/subjects': typeof AuthenticatedCustomerManagementSubjectsRoute
  '/_authenticated/finance/bills': typeof AuthenticatedFinanceBillsRoute
  '/_authenticated/finance/expenses': typeof AuthenticatedFinanceExpensesRoute
  '/_authenticated/finance/groups': typeof AuthenticatedFinanceGroupsRoute
  '/_authenticated/finance/money': typeof AuthenticatedFinanceMoneyRoute
  '/_authenticated/finance/receipts': typeof AuthenticatedFinanceReceiptsRoute
  '/_authenticated/master-data/businesses': typeof AuthenticatedMasterDataBusinessesRoute
  '/_authenticated/master-data/expense-businesses': typeof AuthenticatedMasterDataExpenseBusinessesRoute
  '/_authenticated/reports/businesses': typeof AuthenticatedReportsBusinessesRoute
  '/_authenticated/reports/customers': typeof AuthenticatedReportsCustomersRoute
  '/_authenticated/reports/organizations': typeof AuthenticatedReportsOrganizationsRoute
  '/_authenticated/reports/salespeople': typeof AuthenticatedReportsSalespeopleRoute
  '/_authenticated/reports/sites': typeof AuthenticatedReportsSitesRoute
  '/_authenticated/reports/subjects': typeof AuthenticatedReportsSubjectsRoute
  '/_authenticated/finance/': typeof AuthenticatedFinanceIndexRoute
  '/_authenticated/home/': typeof AuthenticatedHomeIndexRoute
  '/_authenticated/licenses/': typeof AuthenticatedLicensesIndexRoute
  '/_authenticated/reports/': typeof AuthenticatedReportsIndexRoute
  '/_authenticated/contracts/edit/$documentId': typeof AuthenticatedContractsEditDocumentIdRoute
  '/_authenticated/contracts/templates/$templateId': typeof AuthenticatedContractsTemplatesTemplateIdRoute
  '/_authenticated/contracts/view/$documentId': typeof AuthenticatedContractsViewDocumentIdRoute
  '/_authenticated/customer-management/customers/new': typeof AuthenticatedCustomerManagementCustomersNewRoute
  '/_authenticated/finance/groups_/receipt-batch': typeof AuthenticatedFinanceGroupsReceiptBatchRoute
  '/_authenticated/master-data/legal-entities/new': typeof AuthenticatedMasterDataLegalEntitiesNewRoute
  '/_authenticated/orders/contracts/print': typeof AuthenticatedOrdersContractsPrintRoute
  '/_authenticated/orders/groups/$groupId': typeof AuthenticatedOrdersGroupsGroupIdRoute
  '/_authenticated/orders/rentals/$rentalId': typeof AuthenticatedOrdersRentalsRentalIdRoute
  '/_authenticated/orders/rentals/batch-new': typeof AuthenticatedOrdersRentalsBatchNewRoute
  '/_authenticated/orders/rentals/new': typeof AuthenticatedOrdersRentalsNewRoute
  '/_authenticated/orders/service/new': typeof AuthenticatedOrdersServiceNewRoute
  '/_authenticated/system-management/bots/$botId': typeof AuthenticatedSystemManagementBotsBotIdRoute
  '/_authenticated/system-management/roles/$roleId': typeof AuthenticatedSystemManagementRolesRoleIdRoute
  '/_authenticated/system-management/roles/new': typeof AuthenticatedSystemManagementRolesNewRoute
  '/_authenticated/contracts/templates/': typeof AuthenticatedContractsTemplatesIndexRoute
  '/_authenticated/customer-management/customers/': typeof AuthenticatedCustomerManagementCustomersIndexRoute
  '/_authenticated/master-data/legal-entities/': typeof AuthenticatedMasterDataLegalEntitiesIndexRoute
  '/_authenticated/orders/groups/': typeof AuthenticatedOrdersGroupsIndexRoute
  '/_authenticated/orders/rentals/': typeof AuthenticatedOrdersRentalsIndexRoute
  '/_authenticated/orders/service/': typeof AuthenticatedOrdersServiceIndexRoute
  '/_authenticated/system-management/bots/': typeof AuthenticatedSystemManagementBotsIndexRoute
  '/_authenticated/system-management/roles/': typeof AuthenticatedSystemManagementRolesIndexRoute
  '/_authenticated/address/rooms_/$roomId/rentals': typeof AuthenticatedAddressRoomsRoomIdRentalsRoute
  '/_authenticated/contracts/templates/versions/$versionId': typeof AuthenticatedContractsTemplatesVersionsVersionIdRoute
  '/_authenticated/customer-management/customers/$customerId/collection-policy': typeof AuthenticatedCustomerManagementCustomersCustomerIdCollectionPolicyRoute
  '/_authenticated/customer-management/customers/$customerId/documents': typeof AuthenticatedCustomerManagementCustomersCustomerIdDocumentsRoute
  '/_authenticated/customer-management/customers/$customerId/edit': typeof AuthenticatedCustomerManagementCustomersCustomerIdEditRoute
  '/_authenticated/customer-management/subjects_/materials/batch': typeof AuthenticatedCustomerManagementSubjectsMaterialsBatchRoute
  '/_authenticated/master-data/legal-entities/$organizationId/edit': typeof AuthenticatedMasterDataLegalEntitiesOrganizationIdEditRoute
  '/_authenticated/orders/rentals/contract/$rentalId': typeof AuthenticatedOrdersRentalsContractRentalIdRoute
  '/_authenticated/orders/rentals/contracts/batch': typeof AuthenticatedOrdersRentalsContractsBatchRoute
  '/_authenticated/orders/rentals/edit/$rentalId': typeof AuthenticatedOrdersRentalsEditRentalIdRoute
  '/_authenticated/orders/rentals/materials/batch': typeof AuthenticatedOrdersRentalsMaterialsBatchRoute
  '/_authenticated/orders/service/$orderId/edit': typeof AuthenticatedOrdersServiceOrderIdEditRoute
  '/_authenticated/orders/service/contract/$orderId': typeof AuthenticatedOrdersServiceContractOrderIdRoute
  '/_authenticated/orders/service/contracts/batch': typeof AuthenticatedOrdersServiceContractsBatchRoute
  '/_authenticated/customer-management/customers/$customerId/': typeof AuthenticatedCustomerManagementCustomersCustomerIdIndexRoute
  '/_authenticated/orders/service/$orderId/': typeof AuthenticatedOrdersServiceOrderIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/brand-preview'
    | '/finance'
    | '/reports'
    | '/unauthorized'
    | '/auth/forgot-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/status'
    | '/auth/'
    | '/contracts/templates'
    | '/master-data/legal-entities'
    | '/system-management/roles'
    | '/access/accounts'
    | '/access/applications'
    | '/access/members'
    | '/address/rooms'
    | '/address/sites'
    | '/contracts/documents'
    | '/contracts/variables'
    | '/customer-management/calendar'
    | '/customer-management/customer-tags'
    | '/customer-management/subjects'
    | '/finance/bills'
    | '/finance/expenses'
    | '/finance/groups'
    | '/finance/money'
    | '/finance/receipts'
    | '/master-data/businesses'
    | '/master-data/expense-businesses'
    | '/reports/businesses'
    | '/reports/customers'
    | '/reports/organizations'
    | '/reports/salespeople'
    | '/reports/sites'
    | '/reports/subjects'
    | '/finance/'
    | '/home/'
    | '/licenses/'
    | '/reports/'
    | '/contracts/edit/$documentId'
    | '/contracts/templates/$templateId'
    | '/contracts/view/$documentId'
    | '/customer-management/customers/new'
    | '/finance/groups/receipt-batch'
    | '/master-data/legal-entities/new'
    | '/orders/contracts/print'
    | '/orders/groups/$groupId'
    | '/orders/rentals/$rentalId'
    | '/orders/rentals/batch-new'
    | '/orders/rentals/new'
    | '/orders/service/new'
    | '/system-management/bots/$botId'
    | '/system-management/roles/$roleId'
    | '/system-management/roles/new'
    | '/contracts/templates/'
    | '/customer-management/customers/'
    | '/master-data/legal-entities/'
    | '/orders/groups/'
    | '/orders/rentals/'
    | '/orders/service/'
    | '/system-management/bots/'
    | '/system-management/roles/'
    | '/address/rooms/$roomId/rentals'
    | '/contracts/templates/versions/$versionId'
    | '/customer-management/customers/$customerId/collection-policy'
    | '/customer-management/customers/$customerId/documents'
    | '/customer-management/customers/$customerId/edit'
    | '/customer-management/subjects/materials/batch'
    | '/master-data/legal-entities/$organizationId/edit'
    | '/orders/rentals/contract/$rentalId'
    | '/orders/rentals/contracts/batch'
    | '/orders/rentals/edit/$rentalId'
    | '/orders/rentals/materials/batch'
    | '/orders/service/$orderId/edit'
    | '/orders/service/contract/$orderId'
    | '/orders/service/contracts/batch'
    | '/customer-management/customers/$customerId/'
    | '/orders/service/$orderId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/brand-preview'
    | '/unauthorized'
    | '/auth/forgot-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/status'
    | '/auth'
    | '/access/accounts'
    | '/access/applications'
    | '/access/members'
    | '/address/rooms'
    | '/address/sites'
    | '/contracts/documents'
    | '/contracts/variables'
    | '/customer-management/calendar'
    | '/customer-management/customer-tags'
    | '/customer-management/subjects'
    | '/finance/bills'
    | '/finance/expenses'
    | '/finance/groups'
    | '/finance/money'
    | '/finance/receipts'
    | '/master-data/businesses'
    | '/master-data/expense-businesses'
    | '/reports/businesses'
    | '/reports/customers'
    | '/reports/organizations'
    | '/reports/salespeople'
    | '/reports/sites'
    | '/reports/subjects'
    | '/finance'
    | '/home'
    | '/licenses'
    | '/reports'
    | '/contracts/edit/$documentId'
    | '/contracts/templates/$templateId'
    | '/contracts/view/$documentId'
    | '/customer-management/customers/new'
    | '/finance/groups/receipt-batch'
    | '/master-data/legal-entities/new'
    | '/orders/contracts/print'
    | '/orders/groups/$groupId'
    | '/orders/rentals/$rentalId'
    | '/orders/rentals/batch-new'
    | '/orders/rentals/new'
    | '/orders/service/new'
    | '/system-management/bots/$botId'
    | '/system-management/roles/$roleId'
    | '/system-management/roles/new'
    | '/contracts/templates'
    | '/customer-management/customers'
    | '/master-data/legal-entities'
    | '/orders/groups'
    | '/orders/rentals'
    | '/orders/service'
    | '/system-management/bots'
    | '/system-management/roles'
    | '/address/rooms/$roomId/rentals'
    | '/contracts/templates/versions/$versionId'
    | '/customer-management/customers/$customerId/collection-policy'
    | '/customer-management/customers/$customerId/documents'
    | '/customer-management/customers/$customerId/edit'
    | '/customer-management/subjects/materials/batch'
    | '/master-data/legal-entities/$organizationId/edit'
    | '/orders/rentals/contract/$rentalId'
    | '/orders/rentals/contracts/batch'
    | '/orders/rentals/edit/$rentalId'
    | '/orders/rentals/materials/batch'
    | '/orders/service/$orderId/edit'
    | '/orders/service/contract/$orderId'
    | '/orders/service/contracts/batch'
    | '/customer-management/customers/$customerId'
    | '/orders/service/$orderId'
  id:
    | '__root__'
    | '/'
    | '/auth'
    | '/_authenticated'
    | '/brand-preview'
    | '/_authenticated/finance'
    | '/_authenticated/reports'
    | '/_authenticated/unauthorized'
    | '/auth/forgot-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/status'
    | '/auth/'
    | '/_authenticated/contracts/templates'
    | '/_authenticated/master-data/legal-entities'
    | '/_authenticated/system-management/roles'
    | '/_authenticated/access/accounts'
    | '/_authenticated/access/applications'
    | '/_authenticated/access/members'
    | '/_authenticated/address/rooms'
    | '/_authenticated/address/sites'
    | '/_authenticated/contracts/documents'
    | '/_authenticated/contracts/variables'
    | '/_authenticated/customer-management/calendar'
    | '/_authenticated/customer-management/customer-tags'
    | '/_authenticated/customer-management/subjects'
    | '/_authenticated/finance/bills'
    | '/_authenticated/finance/expenses'
    | '/_authenticated/finance/groups'
    | '/_authenticated/finance/money'
    | '/_authenticated/finance/receipts'
    | '/_authenticated/master-data/businesses'
    | '/_authenticated/master-data/expense-businesses'
    | '/_authenticated/reports/businesses'
    | '/_authenticated/reports/customers'
    | '/_authenticated/reports/organizations'
    | '/_authenticated/reports/salespeople'
    | '/_authenticated/reports/sites'
    | '/_authenticated/reports/subjects'
    | '/_authenticated/finance/'
    | '/_authenticated/home/'
    | '/_authenticated/licenses/'
    | '/_authenticated/reports/'
    | '/_authenticated/contracts/edit/$documentId'
    | '/_authenticated/contracts/templates/$templateId'
    | '/_authenticated/contracts/view/$documentId'
    | '/_authenticated/customer-management/customers/new'
    | '/_authenticated/finance/groups_/receipt-batch'
    | '/_authenticated/master-data/legal-entities/new'
    | '/_authenticated/orders/contracts/print'
    | '/_authenticated/orders/groups/$groupId'
    | '/_authenticated/orders/rentals/$rentalId'
    | '/_authenticated/orders/rentals/batch-new'
    | '/_authenticated/orders/rentals/new'
    | '/_authenticated/orders/service/new'
    | '/_authenticated/system-management/bots/$botId'
    | '/_authenticated/system-management/roles/$roleId'
    | '/_authenticated/system-management/roles/new'
    | '/_authenticated/contracts/templates/'
    | '/_authenticated/customer-management/customers/'
    | '/_authenticated/master-data/legal-entities/'
    | '/_authenticated/orders/groups/'
    | '/_authenticated/orders/rentals/'
    | '/_authenticated/orders/service/'
    | '/_authenticated/system-management/bots/'
    | '/_authenticated/system-management/roles/'
    | '/_authenticated/address/rooms_/$roomId/rentals'
    | '/_authenticated/contracts/templates/versions/$versionId'
    | '/_authenticated/customer-management/customers/$customerId/collection-policy'
    | '/_authenticated/customer-management/customers/$customerId/documents'
    | '/_authenticated/customer-management/customers/$customerId/edit'
    | '/_authenticated/customer-management/subjects_/materials/batch'
    | '/_authenticated/master-data/legal-entities/$organizationId/edit'
    | '/_authenticated/orders/rentals/contract/$rentalId'
    | '/_authenticated/orders/rentals/contracts/batch'
    | '/_authenticated/orders/rentals/edit/$rentalId'
    | '/_authenticated/orders/rentals/materials/batch'
    | '/_authenticated/orders/service/$orderId/edit'
    | '/_authenticated/orders/service/contract/$orderId'
    | '/_authenticated/orders/service/contracts/batch'
    | '/_authenticated/customer-management/customers/$customerId/'
    | '/_authenticated/orders/service/$orderId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  BrandPreviewRoute: typeof BrandPreviewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/brand-preview': {
      id: '/brand-preview'
      path: '/brand-preview'
      fullPath: '/brand-preview'
      preLoaderRoute: typeof BrandPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/status': {
      id: '/auth/status'
      path: '/status'
      fullPath: '/auth/status'
      preLoaderRoute: typeof AuthStatusRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/unauthorized': {
      id: '/_authenticated/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof AuthenticatedUnauthorizedRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/finance': {
      id: '/_authenticated/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof AuthenticatedFinanceRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/': {
      id: '/_authenticated/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedReportsRouteRoute
    }
    '/_authenticated/licenses/': {
      id: '/_authenticated/licenses/'
      path: '/licenses'
      fullPath: '/licenses/'
      preLoaderRoute: typeof AuthenticatedLicensesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home/': {
      id: '/_authenticated/home/'
      path: '/home'
      fullPath: '/home/'
      preLoaderRoute: typeof AuthenticatedHomeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/finance/': {
      id: '/_authenticated/finance/'
      path: '/'
      fullPath: '/finance/'
      preLoaderRoute: typeof AuthenticatedFinanceIndexRouteImport
      parentRoute: typeof AuthenticatedFinanceRouteRoute
    }
    '/_authenticated/reports/subjects': {
      id: '/_authenticated/reports/subjects'
      path: '/subjects'
      fullPath: '/reports/subjects'
      preLoaderRoute: typeof AuthenticatedReportsSubjectsRouteImport
      parentRoute: typeof AuthenticatedReportsRouteRoute
    }
    '/_authenticated/reports/sites': {
      id: '/_authenticated/reports/sites'
      path: '/sites'
      fullPath: '/reports/sites'
      preLoaderRoute: typeof AuthenticatedReportsSitesRouteImport
      parentRoute: typeof AuthenticatedReportsRouteRoute
    }
    '/_authenticated/reports/salespeople': {
      id: '/_authenticated/reports/salespeople'
      path: '/salespeople'
      fullPath: '/reports/salespeople'
      preLoaderRoute: typeof AuthenticatedReportsSalespeopleRouteImport
      parentRoute: typeof AuthenticatedReportsRouteRoute
    }
    '/_authenticated/reports/organizations': {
      id: '/_authenticated/reports/organizations'
      path: '/organizations'
      fullPath: '/reports/organizations'
      preLoaderRoute: typeof AuthenticatedReportsOrganizationsRouteImport
      parentRoute: typeof AuthenticatedReportsRouteRoute
    }
    '/_authenticated/reports/customers': {
      id: '/_authenticated/reports/customers'
      path: '/customers'
      fullPath: '/reports/customers'
      preLoaderRoute: typeof AuthenticatedReportsCustomersRouteImport
      parentRoute: typeof AuthenticatedReportsRouteRoute
    }
    '/_authenticated/reports/businesses': {
      id: '/_authenticated/reports/businesses'
      path: '/businesses'
      fullPath: '/reports/businesses'
      preLoaderRoute: typeof AuthenticatedReportsBusinessesRouteImport
      parentRoute: typeof AuthenticatedReportsRouteRoute
    }
    '/_authenticated/master-data/expense-businesses': {
      id: '/_authenticated/master-data/expense-businesses'
      path: '/master-data/expense-businesses'
      fullPath: '/master-data/expense-businesses'
      preLoaderRoute: typeof AuthenticatedMasterDataExpenseBusinessesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/master-data/businesses': {
      id: '/_authenticated/master-data/businesses'
      path: '/master-data/businesses'
      fullPath: '/master-data/businesses'
      preLoaderRoute: typeof AuthenticatedMasterDataBusinessesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/finance/receipts': {
      id: '/_authenticated/finance/receipts'
      path: '/receipts'
      fullPath: '/finance/receipts'
      preLoaderRoute: typeof AuthenticatedFinanceReceiptsRouteImport
      parentRoute: typeof AuthenticatedFinanceRouteRoute
    }
    '/_authenticated/finance/money': {
      id: '/_authenticated/finance/money'
      path: '/money'
      fullPath: '/finance/money'
      preLoaderRoute: typeof AuthenticatedFinanceMoneyRouteImport
      parentRoute: typeof AuthenticatedFinanceRouteRoute
    }
    '/_authenticated/finance/groups': {
      id: '/_authenticated/finance/groups'
      path: '/groups'
      fullPath: '/finance/groups'
      preLoaderRoute: typeof AuthenticatedFinanceGroupsRouteImport
      parentRoute: typeof AuthenticatedFinanceRouteRoute
    }
    '/_authenticated/finance/expenses': {
      id: '/_authenticated/finance/expenses'
      path: '/expenses'
      fullPath: '/finance/expenses'
      preLoaderRoute: typeof AuthenticatedFinanceExpensesRouteImport
      parentRoute: typeof AuthenticatedFinanceRouteRoute
    }
    '/_authenticated/finance/bills': {
      id: '/_authenticated/finance/bills'
      path: '/bills'
      fullPath: '/finance/bills'
      preLoaderRoute: typeof AuthenticatedFinanceBillsRouteImport
      parentRoute: typeof AuthenticatedFinanceRouteRoute
    }
    '/_authenticated/customer-management/subjects': {
      id: '/_authenticated/customer-management/subjects'
      path: '/customer-management/subjects'
      fullPath: '/customer-management/subjects'
      preLoaderRoute: typeof AuthenticatedCustomerManagementSubjectsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customer-management/customer-tags': {
      id: '/_authenticated/customer-management/customer-tags'
      path: '/customer-management/customer-tags'
      fullPath: '/customer-management/customer-tags'
      preLoaderRoute: typeof AuthenticatedCustomerManagementCustomerTagsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customer-management/calendar': {
      id: '/_authenticated/customer-management/calendar'
      path: '/customer-management/calendar'
      fullPath: '/customer-management/calendar'
      preLoaderRoute: typeof AuthenticatedCustomerManagementCalendarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/variables': {
      id: '/_authenticated/contracts/variables'
      path: '/contracts/variables'
      fullPath: '/contracts/variables'
      preLoaderRoute: typeof AuthenticatedContractsVariablesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/documents': {
      id: '/_authenticated/contracts/documents'
      path: '/contracts/documents'
      fullPath: '/contracts/documents'
      preLoaderRoute: typeof AuthenticatedContractsDocumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/address/sites': {
      id: '/_authenticated/address/sites'
      path: '/address/sites'
      fullPath: '/address/sites'
      preLoaderRoute: typeof AuthenticatedAddressSitesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/address/rooms': {
      id: '/_authenticated/address/rooms'
      path: '/address/rooms'
      fullPath: '/address/rooms'
      preLoaderRoute: typeof AuthenticatedAddressRoomsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/access/members': {
      id: '/_authenticated/access/members'
      path: '/access/members'
      fullPath: '/access/members'
      preLoaderRoute: typeof AuthenticatedAccessMembersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/access/applications': {
      id: '/_authenticated/access/applications'
      path: '/access/applications'
      fullPath: '/access/applications'
      preLoaderRoute: typeof AuthenticatedAccessApplicationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/access/accounts': {
      id: '/_authenticated/access/accounts'
      path: '/access/accounts'
      fullPath: '/access/accounts'
      preLoaderRoute: typeof AuthenticatedAccessAccountsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/system-management/roles': {
      id: '/_authenticated/system-management/roles'
      path: '/system-management/roles'
      fullPath: '/system-management/roles'
      preLoaderRoute: typeof AuthenticatedSystemManagementRolesRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/master-data/legal-entities': {
      id: '/_authenticated/master-data/legal-entities'
      path: '/master-data/legal-entities'
      fullPath: '/master-data/legal-entities'
      preLoaderRoute: typeof AuthenticatedMasterDataLegalEntitiesRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/templates': {
      id: '/_authenticated/contracts/templates'
      path: '/contracts/templates'
      fullPath: '/contracts/templates'
      preLoaderRoute: typeof AuthenticatedContractsTemplatesRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/system-management/roles/': {
      id: '/_authenticated/system-management/roles/'
      path: '/'
      fullPath: '/system-management/roles/'
      preLoaderRoute: typeof AuthenticatedSystemManagementRolesIndexRouteImport
      parentRoute: typeof AuthenticatedSystemManagementRolesRouteRoute
    }
    '/_authenticated/system-management/bots/': {
      id: '/_authenticated/system-management/bots/'
      path: '/system-management/bots'
      fullPath: '/system-management/bots/'
      preLoaderRoute: typeof AuthenticatedSystemManagementBotsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/service/': {
      id: '/_authenticated/orders/service/'
      path: '/orders/service'
      fullPath: '/orders/service/'
      preLoaderRoute: typeof AuthenticatedOrdersServiceIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/rentals/': {
      id: '/_authenticated/orders/rentals/'
      path: '/orders/rentals'
      fullPath: '/orders/rentals/'
      preLoaderRoute: typeof AuthenticatedOrdersRentalsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/groups/': {
      id: '/_authenticated/orders/groups/'
      path: '/orders/groups'
      fullPath: '/orders/groups/'
      preLoaderRoute: typeof AuthenticatedOrdersGroupsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/master-data/legal-entities/': {
      id: '/_authenticated/master-data/legal-entities/'
      path: '/'
      fullPath: '/master-data/legal-entities/'
      preLoaderRoute: typeof AuthenticatedMasterDataLegalEntitiesIndexRouteImport
      parentRoute: typeof AuthenticatedMasterDataLegalEntitiesRouteRoute
    }
    '/_authenticated/customer-management/customers/': {
      id: '/_authenticated/customer-management/customers/'
      path: '/customer-management/customers'
      fullPath: '/customer-management/customers/'
      preLoaderRoute: typeof AuthenticatedCustomerManagementCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/templates/': {
      id: '/_authenticated/contracts/templates/'
      path: '/'
      fullPath: '/contracts/templates/'
      preLoaderRoute: typeof AuthenticatedContractsTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedContractsTemplatesRouteRoute
    }
    '/_authenticated/system-management/roles/new': {
      id: '/_authenticated/system-management/roles/new'
      path: '/new'
      fullPath: '/system-management/roles/new'
      preLoaderRoute: typeof AuthenticatedSystemManagementRolesNewRouteImport
      parentRoute: typeof AuthenticatedSystemManagementRolesRouteRoute
    }
    '/_authenticated/system-management/roles/$roleId': {
      id: '/_authenticated/system-management/roles/$roleId'
      path: '/$roleId'
      fullPath: '/system-management/roles/$roleId'
      preLoaderRoute: typeof AuthenticatedSystemManagementRolesRoleIdRouteImport
      parentRoute: typeof AuthenticatedSystemManagementRolesRouteRoute
    }
    '/_authenticated/system-management/bots/$botId': {
      id: '/_authenticated/system-management/bots/$botId'
      path: '/system-management/bots/$botId'
      fullPath: '/system-management/bots/$botId'
      preLoaderRoute: typeof AuthenticatedSystemManagementBotsBotIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/service/new': {
      id: '/_authenticated/orders/service/new'
      path: '/orders/service/new'
      fullPath: '/orders/service/new'
      preLoaderRoute: typeof AuthenticatedOrdersServiceNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/rentals/new': {
      id: '/_authenticated/orders/rentals/new'
      path: '/orders/rentals/new'
      fullPath: '/orders/rentals/new'
      preLoaderRoute: typeof AuthenticatedOrdersRentalsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/rentals/batch-new': {
      id: '/_authenticated/orders/rentals/batch-new'
      path: '/orders/rentals/batch-new'
      fullPath: '/orders/rentals/batch-new'
      preLoaderRoute: typeof AuthenticatedOrdersRentalsBatchNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/rentals/$rentalId': {
      id: '/_authenticated/orders/rentals/$rentalId'
      path: '/orders/rentals/$rentalId'
      fullPath: '/orders/rentals/$rentalId'
      preLoaderRoute: typeof AuthenticatedOrdersRentalsRentalIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/groups/$groupId': {
      id: '/_authenticated/orders/groups/$groupId'
      path: '/orders/groups/$groupId'
      fullPath: '/orders/groups/$groupId'
      preLoaderRoute: typeof AuthenticatedOrdersGroupsGroupIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/contracts/print': {
      id: '/_authenticated/orders/contracts/print'
      path: '/orders/contracts/print'
      fullPath: '/orders/contracts/print'
      preLoaderRoute: typeof AuthenticatedOrdersContractsPrintRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/master-data/legal-entities/new': {
      id: '/_authenticated/master-data/legal-entities/new'
      path: '/new'
      fullPath: '/master-data/legal-entities/new'
      preLoaderRoute: typeof AuthenticatedMasterDataLegalEntitiesNewRouteImport
      parentRoute: typeof AuthenticatedMasterDataLegalEntitiesRouteRoute
    }
    '/_authenticated/finance/groups_/receipt-batch': {
      id: '/_authenticated/finance/groups_/receipt-batch'
      path: '/groups/receipt-batch'
      fullPath: '/finance/groups/receipt-batch'
      preLoaderRoute: typeof AuthenticatedFinanceGroupsReceiptBatchRouteImport
      parentRoute: typeof AuthenticatedFinanceRouteRoute
    }
    '/_authenticated/customer-management/customers/new': {
      id: '/_authenticated/customer-management/customers/new'
      path: '/customer-management/customers/new'
      fullPath: '/customer-management/customers/new'
      preLoaderRoute: typeof AuthenticatedCustomerManagementCustomersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/view/$documentId': {
      id: '/_authenticated/contracts/view/$documentId'
      path: '/contracts/view/$documentId'
      fullPath: '/contracts/view/$documentId'
      preLoaderRoute: typeof AuthenticatedContractsViewDocumentIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/templates/$templateId': {
      id: '/_authenticated/contracts/templates/$templateId'
      path: '/$templateId'
      fullPath: '/contracts/templates/$templateId'
      preLoaderRoute: typeof AuthenticatedContractsTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedContractsTemplatesRouteRoute
    }
    '/_authenticated/contracts/edit/$documentId': {
      id: '/_authenticated/contracts/edit/$documentId'
      path: '/contracts/edit/$documentId'
      fullPath: '/contracts/edit/$documentId'
      preLoaderRoute: typeof AuthenticatedContractsEditDocumentIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/service/$orderId/': {
      id: '/_authenticated/orders/service/$orderId/'
      path: '/orders/service/$orderId'
      fullPath: '/orders/service/$orderId/'
      preLoaderRoute: typeof AuthenticatedOrdersServiceOrderIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customer-management/customers/$customerId/': {
      id: '/_authenticated/customer-management/customers/$customerId/'
      path: '/customer-management/customers/$customerId'
      fullPath: '/customer-management/customers/$customerId/'
      preLoaderRoute: typeof AuthenticatedCustomerManagementCustomersCustomerIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/service/contracts/batch': {
      id: '/_authenticated/orders/service/contracts/batch'
      path: '/orders/service/contracts/batch'
      fullPath: '/orders/service/contracts/batch'
      preLoaderRoute: typeof AuthenticatedOrdersServiceContractsBatchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/service/contract/$orderId': {
      id: '/_authenticated/orders/service/contract/$orderId'
      path: '/orders/service/contract/$orderId'
      fullPath: '/orders/service/contract/$orderId'
      preLoaderRoute: typeof AuthenticatedOrdersServiceContractOrderIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/service/$orderId/edit': {
      id: '/_authenticated/orders/service/$orderId/edit'
      path: '/orders/service/$orderId/edit'
      fullPath: '/orders/service/$orderId/edit'
      preLoaderRoute: typeof AuthenticatedOrdersServiceOrderIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/rentals/materials/batch': {
      id: '/_authenticated/orders/rentals/materials/batch'
      path: '/orders/rentals/materials/batch'
      fullPath: '/orders/rentals/materials/batch'
      preLoaderRoute: typeof AuthenticatedOrdersRentalsMaterialsBatchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/rentals/edit/$rentalId': {
      id: '/_authenticated/orders/rentals/edit/$rentalId'
      path: '/orders/rentals/edit/$rentalId'
      fullPath: '/orders/rentals/edit/$rentalId'
      preLoaderRoute: typeof AuthenticatedOrdersRentalsEditRentalIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/rentals/contracts/batch': {
      id: '/_authenticated/orders/rentals/contracts/batch'
      path: '/orders/rentals/contracts/batch'
      fullPath: '/orders/rentals/contracts/batch'
      preLoaderRoute: typeof AuthenticatedOrdersRentalsContractsBatchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders/rentals/contract/$rentalId': {
      id: '/_authenticated/orders/rentals/contract/$rentalId'
      path: '/orders/rentals/contract/$rentalId'
      fullPath: '/orders/rentals/contract/$rentalId'
      preLoaderRoute: typeof AuthenticatedOrdersRentalsContractRentalIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/master-data/legal-entities/$organizationId/edit': {
      id: '/_authenticated/master-data/legal-entities/$organizationId/edit'
      path: '/$organizationId/edit'
      fullPath: '/master-data/legal-entities/$organizationId/edit'
      preLoaderRoute: typeof AuthenticatedMasterDataLegalEntitiesOrganizationIdEditRouteImport
      parentRoute: typeof AuthenticatedMasterDataLegalEntitiesRouteRoute
    }
    '/_authenticated/customer-management/subjects_/materials/batch': {
      id: '/_authenticated/customer-management/subjects_/materials/batch'
      path: '/customer-management/subjects/materials/batch'
      fullPath: '/customer-management/subjects/materials/batch'
      preLoaderRoute: typeof AuthenticatedCustomerManagementSubjectsMaterialsBatchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customer-management/customers/$customerId/edit': {
      id: '/_authenticated/customer-management/customers/$customerId/edit'
      path: '/customer-management/customers/$customerId/edit'
      fullPath: '/customer-management/customers/$customerId/edit'
      preLoaderRoute: typeof AuthenticatedCustomerManagementCustomersCustomerIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customer-management/customers/$customerId/documents': {
      id: '/_authenticated/customer-management/customers/$customerId/documents'
      path: '/customer-management/customers/$customerId/documents'
      fullPath: '/customer-management/customers/$customerId/documents'
      preLoaderRoute: typeof AuthenticatedCustomerManagementCustomersCustomerIdDocumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customer-management/customers/$customerId/collection-policy': {
      id: '/_authenticated/customer-management/customers/$customerId/collection-policy'
      path: '/customer-management/customers/$customerId/collection-policy'
      fullPath: '/customer-management/customers/$customerId/collection-policy'
      preLoaderRoute: typeof AuthenticatedCustomerManagementCustomersCustomerIdCollectionPolicyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/templates/versions/$versionId': {
      id: '/_authenticated/contracts/templates/versions/$versionId'
      path: '/versions/$versionId'
      fullPath: '/contracts/templates/versions/$versionId'
      preLoaderRoute: typeof AuthenticatedContractsTemplatesVersionsVersionIdRouteImport
      parentRoute: typeof AuthenticatedContractsTemplatesRouteRoute
    }
    '/_authenticated/address/rooms_/$roomId/rentals': {
      id: '/_authenticated/address/rooms_/$roomId/rentals'
      path: '/address/rooms/$roomId/rentals'
      fullPath: '/address/rooms/$roomId/rentals'
      preLoaderRoute: typeof AuthenticatedAddressRoomsRoomIdRentalsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthSigninRoute: typeof AuthSigninRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthStatusRoute: typeof AuthStatusRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthStatusRoute: AuthStatusRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface AuthenticatedFinanceRouteRouteChildren {
  AuthenticatedFinanceBillsRoute: typeof AuthenticatedFinanceBillsRoute
  AuthenticatedFinanceExpensesRoute: typeof AuthenticatedFinanceExpensesRoute
  AuthenticatedFinanceGroupsRoute: typeof AuthenticatedFinanceGroupsRoute
  AuthenticatedFinanceMoneyRoute: typeof AuthenticatedFinanceMoneyRoute
  AuthenticatedFinanceReceiptsRoute: typeof AuthenticatedFinanceReceiptsRoute
  AuthenticatedFinanceIndexRoute: typeof AuthenticatedFinanceIndexRoute
  AuthenticatedFinanceGroupsReceiptBatchRoute: typeof AuthenticatedFinanceGroupsReceiptBatchRoute
}

const AuthenticatedFinanceRouteRouteChildren: AuthenticatedFinanceRouteRouteChildren =
  {
    AuthenticatedFinanceBillsRoute: AuthenticatedFinanceBillsRoute,
    AuthenticatedFinanceExpensesRoute: AuthenticatedFinanceExpensesRoute,
    AuthenticatedFinanceGroupsRoute: AuthenticatedFinanceGroupsRoute,
    AuthenticatedFinanceMoneyRoute: AuthenticatedFinanceMoneyRoute,
    AuthenticatedFinanceReceiptsRoute: AuthenticatedFinanceReceiptsRoute,
    AuthenticatedFinanceIndexRoute: AuthenticatedFinanceIndexRoute,
    AuthenticatedFinanceGroupsReceiptBatchRoute:
      AuthenticatedFinanceGroupsReceiptBatchRoute,
  }

const AuthenticatedFinanceRouteRouteWithChildren =
  AuthenticatedFinanceRouteRoute._addFileChildren(
    AuthenticatedFinanceRouteRouteChildren,
  )

interface AuthenticatedReportsRouteRouteChildren {
  AuthenticatedReportsBusinessesRoute: typeof AuthenticatedReportsBusinessesRoute
  AuthenticatedReportsCustomersRoute: typeof AuthenticatedReportsCustomersRoute
  AuthenticatedReportsOrganizationsRoute: typeof AuthenticatedReportsOrganizationsRoute
  AuthenticatedReportsSalespeopleRoute: typeof AuthenticatedReportsSalespeopleRoute
  AuthenticatedReportsSitesRoute: typeof AuthenticatedReportsSitesRoute
  AuthenticatedReportsSubjectsRoute: typeof AuthenticatedReportsSubjectsRoute
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute
}

const AuthenticatedReportsRouteRouteChildren: AuthenticatedReportsRouteRouteChildren =
  {
    AuthenticatedReportsBusinessesRoute: AuthenticatedReportsBusinessesRoute,
    AuthenticatedReportsCustomersRoute: AuthenticatedReportsCustomersRoute,
    AuthenticatedReportsOrganizationsRoute:
      AuthenticatedReportsOrganizationsRoute,
    AuthenticatedReportsSalespeopleRoute: AuthenticatedReportsSalespeopleRoute,
    AuthenticatedReportsSitesRoute: AuthenticatedReportsSitesRoute,
    AuthenticatedReportsSubjectsRoute: AuthenticatedReportsSubjectsRoute,
    AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
  }

const AuthenticatedReportsRouteRouteWithChildren =
  AuthenticatedReportsRouteRoute._addFileChildren(
    AuthenticatedReportsRouteRouteChildren,
  )

interface AuthenticatedContractsTemplatesRouteRouteChildren {
  AuthenticatedContractsTemplatesTemplateIdRoute: typeof AuthenticatedContractsTemplatesTemplateIdRoute
  AuthenticatedContractsTemplatesIndexRoute: typeof AuthenticatedContractsTemplatesIndexRoute
  AuthenticatedContractsTemplatesVersionsVersionIdRoute: typeof AuthenticatedContractsTemplatesVersionsVersionIdRoute
}

const AuthenticatedContractsTemplatesRouteRouteChildren: AuthenticatedContractsTemplatesRouteRouteChildren =
  {
    AuthenticatedContractsTemplatesTemplateIdRoute:
      AuthenticatedContractsTemplatesTemplateIdRoute,
    AuthenticatedContractsTemplatesIndexRoute:
      AuthenticatedContractsTemplatesIndexRoute,
    AuthenticatedContractsTemplatesVersionsVersionIdRoute:
      AuthenticatedContractsTemplatesVersionsVersionIdRoute,
  }

const AuthenticatedContractsTemplatesRouteRouteWithChildren =
  AuthenticatedContractsTemplatesRouteRoute._addFileChildren(
    AuthenticatedContractsTemplatesRouteRouteChildren,
  )

interface AuthenticatedMasterDataLegalEntitiesRouteRouteChildren {
  AuthenticatedMasterDataLegalEntitiesNewRoute: typeof AuthenticatedMasterDataLegalEntitiesNewRoute
  AuthenticatedMasterDataLegalEntitiesIndexRoute: typeof AuthenticatedMasterDataLegalEntitiesIndexRoute
  AuthenticatedMasterDataLegalEntitiesOrganizationIdEditRoute: typeof AuthenticatedMasterDataLegalEntitiesOrganizationIdEditRoute
}

const AuthenticatedMasterDataLegalEntitiesRouteRouteChildren: AuthenticatedMasterDataLegalEntitiesRouteRouteChildren =
  {
    AuthenticatedMasterDataLegalEntitiesNewRoute:
      AuthenticatedMasterDataLegalEntitiesNewRoute,
    AuthenticatedMasterDataLegalEntitiesIndexRoute:
      AuthenticatedMasterDataLegalEntitiesIndexRoute,
    AuthenticatedMasterDataLegalEntitiesOrganizationIdEditRoute:
      AuthenticatedMasterDataLegalEntitiesOrganizationIdEditRoute,
  }

const AuthenticatedMasterDataLegalEntitiesRouteRouteWithChildren =
  AuthenticatedMasterDataLegalEntitiesRouteRoute._addFileChildren(
    AuthenticatedMasterDataLegalEntitiesRouteRouteChildren,
  )

interface AuthenticatedSystemManagementRolesRouteRouteChildren {
  AuthenticatedSystemManagementRolesRoleIdRoute: typeof AuthenticatedSystemManagementRolesRoleIdRoute
  AuthenticatedSystemManagementRolesNewRoute: typeof AuthenticatedSystemManagementRolesNewRoute
  AuthenticatedSystemManagementRolesIndexRoute: typeof AuthenticatedSystemManagementRolesIndexRoute
}

const AuthenticatedSystemManagementRolesRouteRouteChildren: AuthenticatedSystemManagementRolesRouteRouteChildren =
  {
    AuthenticatedSystemManagementRolesRoleIdRoute:
      AuthenticatedSystemManagementRolesRoleIdRoute,
    AuthenticatedSystemManagementRolesNewRoute:
      AuthenticatedSystemManagementRolesNewRoute,
    AuthenticatedSystemManagementRolesIndexRoute:
      AuthenticatedSystemManagementRolesIndexRoute,
  }

const AuthenticatedSystemManagementRolesRouteRouteWithChildren =
  AuthenticatedSystemManagementRolesRouteRoute._addFileChildren(
    AuthenticatedSystemManagementRolesRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedFinanceRouteRoute: typeof AuthenticatedFinanceRouteRouteWithChildren
  AuthenticatedReportsRouteRoute: typeof AuthenticatedReportsRouteRouteWithChildren
  AuthenticatedUnauthorizedRoute: typeof AuthenticatedUnauthorizedRoute
  AuthenticatedContractsTemplatesRouteRoute: typeof AuthenticatedContractsTemplatesRouteRouteWithChildren
  AuthenticatedMasterDataLegalEntitiesRouteRoute: typeof AuthenticatedMasterDataLegalEntitiesRouteRouteWithChildren
  AuthenticatedSystemManagementRolesRouteRoute: typeof AuthenticatedSystemManagementRolesRouteRouteWithChildren
  AuthenticatedAccessAccountsRoute: typeof AuthenticatedAccessAccountsRoute
  AuthenticatedAccessApplicationsRoute: typeof AuthenticatedAccessApplicationsRoute
  AuthenticatedAccessMembersRoute: typeof AuthenticatedAccessMembersRoute
  AuthenticatedAddressRoomsRoute: typeof AuthenticatedAddressRoomsRoute
  AuthenticatedAddressSitesRoute: typeof AuthenticatedAddressSitesRoute
  AuthenticatedContractsDocumentsRoute: typeof AuthenticatedContractsDocumentsRoute
  AuthenticatedContractsVariablesRoute: typeof AuthenticatedContractsVariablesRoute
  AuthenticatedCustomerManagementCalendarRoute: typeof AuthenticatedCustomerManagementCalendarRoute
  AuthenticatedCustomerManagementCustomerTagsRoute: typeof AuthenticatedCustomerManagementCustomerTagsRoute
  AuthenticatedCustomerManagementSubjectsRoute: typeof AuthenticatedCustomerManagementSubjectsRoute
  AuthenticatedMasterDataBusinessesRoute: typeof AuthenticatedMasterDataBusinessesRoute
  AuthenticatedMasterDataExpenseBusinessesRoute: typeof AuthenticatedMasterDataExpenseBusinessesRoute
  AuthenticatedHomeIndexRoute: typeof AuthenticatedHomeIndexRoute
  AuthenticatedLicensesIndexRoute: typeof AuthenticatedLicensesIndexRoute
  AuthenticatedContractsEditDocumentIdRoute: typeof AuthenticatedContractsEditDocumentIdRoute
  AuthenticatedContractsViewDocumentIdRoute: typeof AuthenticatedContractsViewDocumentIdRoute
  AuthenticatedCustomerManagementCustomersNewRoute: typeof AuthenticatedCustomerManagementCustomersNewRoute
  AuthenticatedOrdersContractsPrintRoute: typeof AuthenticatedOrdersContractsPrintRoute
  AuthenticatedOrdersGroupsGroupIdRoute: typeof AuthenticatedOrdersGroupsGroupIdRoute
  AuthenticatedOrdersRentalsRentalIdRoute: typeof AuthenticatedOrdersRentalsRentalIdRoute
  AuthenticatedOrdersRentalsBatchNewRoute: typeof AuthenticatedOrdersRentalsBatchNewRoute
  AuthenticatedOrdersRentalsNewRoute: typeof AuthenticatedOrdersRentalsNewRoute
  AuthenticatedOrdersServiceNewRoute: typeof AuthenticatedOrdersServiceNewRoute
  AuthenticatedSystemManagementBotsBotIdRoute: typeof AuthenticatedSystemManagementBotsBotIdRoute
  AuthenticatedCustomerManagementCustomersIndexRoute: typeof AuthenticatedCustomerManagementCustomersIndexRoute
  AuthenticatedOrdersGroupsIndexRoute: typeof AuthenticatedOrdersGroupsIndexRoute
  AuthenticatedOrdersRentalsIndexRoute: typeof AuthenticatedOrdersRentalsIndexRoute
  AuthenticatedOrdersServiceIndexRoute: typeof AuthenticatedOrdersServiceIndexRoute
  AuthenticatedSystemManagementBotsIndexRoute: typeof AuthenticatedSystemManagementBotsIndexRoute
  AuthenticatedAddressRoomsRoomIdRentalsRoute: typeof AuthenticatedAddressRoomsRoomIdRentalsRoute
  AuthenticatedCustomerManagementCustomersCustomerIdCollectionPolicyRoute: typeof AuthenticatedCustomerManagementCustomersCustomerIdCollectionPolicyRoute
  AuthenticatedCustomerManagementCustomersCustomerIdDocumentsRoute: typeof AuthenticatedCustomerManagementCustomersCustomerIdDocumentsRoute
  AuthenticatedCustomerManagementCustomersCustomerIdEditRoute: typeof AuthenticatedCustomerManagementCustomersCustomerIdEditRoute
  AuthenticatedCustomerManagementSubjectsMaterialsBatchRoute: typeof AuthenticatedCustomerManagementSubjectsMaterialsBatchRoute
  AuthenticatedOrdersRentalsContractRentalIdRoute: typeof AuthenticatedOrdersRentalsContractRentalIdRoute
  AuthenticatedOrdersRentalsContractsBatchRoute: typeof AuthenticatedOrdersRentalsContractsBatchRoute
  AuthenticatedOrdersRentalsEditRentalIdRoute: typeof AuthenticatedOrdersRentalsEditRentalIdRoute
  AuthenticatedOrdersRentalsMaterialsBatchRoute: typeof AuthenticatedOrdersRentalsMaterialsBatchRoute
  AuthenticatedOrdersServiceOrderIdEditRoute: typeof AuthenticatedOrdersServiceOrderIdEditRoute
  AuthenticatedOrdersServiceContractOrderIdRoute: typeof AuthenticatedOrdersServiceContractOrderIdRoute
  AuthenticatedOrdersServiceContractsBatchRoute: typeof AuthenticatedOrdersServiceContractsBatchRoute
  AuthenticatedCustomerManagementCustomersCustomerIdIndexRoute: typeof AuthenticatedCustomerManagementCustomersCustomerIdIndexRoute
  AuthenticatedOrdersServiceOrderIdIndexRoute: typeof AuthenticatedOrdersServiceOrderIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedFinanceRouteRoute: AuthenticatedFinanceRouteRouteWithChildren,
  AuthenticatedReportsRouteRoute: AuthenticatedReportsRouteRouteWithChildren,
  AuthenticatedUnauthorizedRoute: AuthenticatedUnauthorizedRoute,
  AuthenticatedContractsTemplatesRouteRoute:
    AuthenticatedContractsTemplatesRouteRouteWithChildren,
  AuthenticatedMasterDataLegalEntitiesRouteRoute:
    AuthenticatedMasterDataLegalEntitiesRouteRouteWithChildren,
  AuthenticatedSystemManagementRolesRouteRoute:
    AuthenticatedSystemManagementRolesRouteRouteWithChildren,
  AuthenticatedAccessAccountsRoute: AuthenticatedAccessAccountsRoute,
  AuthenticatedAccessApplicationsRoute: AuthenticatedAccessApplicationsRoute,
  AuthenticatedAccessMembersRoute: AuthenticatedAccessMembersRoute,
  AuthenticatedAddressRoomsRoute: AuthenticatedAddressRoomsRoute,
  AuthenticatedAddressSitesRoute: AuthenticatedAddressSitesRoute,
  AuthenticatedContractsDocumentsRoute: AuthenticatedContractsDocumentsRoute,
  AuthenticatedContractsVariablesRoute: AuthenticatedContractsVariablesRoute,
  AuthenticatedCustomerManagementCalendarRoute:
    AuthenticatedCustomerManagementCalendarRoute,
  AuthenticatedCustomerManagementCustomerTagsRoute:
    AuthenticatedCustomerManagementCustomerTagsRoute,
  AuthenticatedCustomerManagementSubjectsRoute:
    AuthenticatedCustomerManagementSubjectsRoute,
  AuthenticatedMasterDataBusinessesRoute:
    AuthenticatedMasterDataBusinessesRoute,
  AuthenticatedMasterDataExpenseBusinessesRoute:
    AuthenticatedMasterDataExpenseBusinessesRoute,
  AuthenticatedHomeIndexRoute: AuthenticatedHomeIndexRoute,
  AuthenticatedLicensesIndexRoute: AuthenticatedLicensesIndexRoute,
  AuthenticatedContractsEditDocumentIdRoute:
    AuthenticatedContractsEditDocumentIdRoute,
  AuthenticatedContractsViewDocumentIdRoute:
    AuthenticatedContractsViewDocumentIdRoute,
  AuthenticatedCustomerManagementCustomersNewRoute:
    AuthenticatedCustomerManagementCustomersNewRoute,
  AuthenticatedOrdersContractsPrintRoute:
    AuthenticatedOrdersContractsPrintRoute,
  AuthenticatedOrdersGroupsGroupIdRoute: AuthenticatedOrdersGroupsGroupIdRoute,
  AuthenticatedOrdersRentalsRentalIdRoute:
    AuthenticatedOrdersRentalsRentalIdRoute,
  AuthenticatedOrdersRentalsBatchNewRoute:
    AuthenticatedOrdersRentalsBatchNewRoute,
  AuthenticatedOrdersRentalsNewRoute: AuthenticatedOrdersRentalsNewRoute,
  AuthenticatedOrdersServiceNewRoute: AuthenticatedOrdersServiceNewRoute,
  AuthenticatedSystemManagementBotsBotIdRoute:
    AuthenticatedSystemManagementBotsBotIdRoute,
  AuthenticatedCustomerManagementCustomersIndexRoute:
    AuthenticatedCustomerManagementCustomersIndexRoute,
  AuthenticatedOrdersGroupsIndexRoute: AuthenticatedOrdersGroupsIndexRoute,
  AuthenticatedOrdersRentalsIndexRoute: AuthenticatedOrdersRentalsIndexRoute,
  AuthenticatedOrdersServiceIndexRoute: AuthenticatedOrdersServiceIndexRoute,
  AuthenticatedSystemManagementBotsIndexRoute:
    AuthenticatedSystemManagementBotsIndexRoute,
  AuthenticatedAddressRoomsRoomIdRentalsRoute:
    AuthenticatedAddressRoomsRoomIdRentalsRoute,
  AuthenticatedCustomerManagementCustomersCustomerIdCollectionPolicyRoute:
    AuthenticatedCustomerManagementCustomersCustomerIdCollectionPolicyRoute,
  AuthenticatedCustomerManagementCustomersCustomerIdDocumentsRoute:
    AuthenticatedCustomerManagementCustomersCustomerIdDocumentsRoute,
  AuthenticatedCustomerManagementCustomersCustomerIdEditRoute:
    AuthenticatedCustomerManagementCustomersCustomerIdEditRoute,
  AuthenticatedCustomerManagementSubjectsMaterialsBatchRoute:
    AuthenticatedCustomerManagementSubjectsMaterialsBatchRoute,
  AuthenticatedOrdersRentalsContractRentalIdRoute:
    AuthenticatedOrdersRentalsContractRentalIdRoute,
  AuthenticatedOrdersRentalsContractsBatchRoute:
    AuthenticatedOrdersRentalsContractsBatchRoute,
  AuthenticatedOrdersRentalsEditRentalIdRoute:
    AuthenticatedOrdersRentalsEditRentalIdRoute,
  AuthenticatedOrdersRentalsMaterialsBatchRoute:
    AuthenticatedOrdersRentalsMaterialsBatchRoute,
  AuthenticatedOrdersServiceOrderIdEditRoute:
    AuthenticatedOrdersServiceOrderIdEditRoute,
  AuthenticatedOrdersServiceContractOrderIdRoute:
    AuthenticatedOrdersServiceContractOrderIdRoute,
  AuthenticatedOrdersServiceContractsBatchRoute:
    AuthenticatedOrdersServiceContractsBatchRoute,
  AuthenticatedCustomerManagementCustomersCustomerIdIndexRoute:
    AuthenticatedCustomerManagementCustomersCustomerIdIndexRoute,
  AuthenticatedOrdersServiceOrderIdIndexRoute:
    AuthenticatedOrdersServiceOrderIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  BrandPreviewRoute: BrandPreviewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
